import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

export function TechnicalInspectionValidUntilDatePicker() {
  return (
    <Field
      type="apiDate"
      name="technicalInspectionValidUntil"
      label={i18n.t('entity.vehicle.labels.inspectionValidUntil')}
    />
  );
}
